module.exports = __webpack_public_path__ + "img/diagnosis.2e85758f.png";